// Persists the Ongoing Loads sort selection to localStorage so it survives
// page refreshes and logout/login. Kept in the store layer (not the slice)
// and validated against the known sort values so stale data falls back to
// no sorting. Mirrors the rows-per-page persistence in loadsSlice.ts.

const SORT_STORAGE_KEY = 'ongoing-loads-sort'
const VALID_SORT_VALUES = ['', 'delay-asc', 'delay-desc', 'delivery-status', 'pickup-asc', 'pickup-desc', 'delivery-asc', 'delivery-desc']

export const readPersistedOngoingLoadsSort = (): string => {
    try {
        const stored = localStorage.getItem(SORT_STORAGE_KEY)
        return stored !== null && VALID_SORT_VALUES.includes(stored) ? stored : ''
    } catch {
        return ''
    }
}

export const persistOngoingLoadsSort = (sort: string): void => {
    try {
        localStorage.setItem(SORT_STORAGE_KEY, sort)
    } catch {
        // ignore storage failures (private mode, quota, etc.)
    }
}
